import { Suspense, lazy } from 'react'
import { Switch, Redirect, Route } from 'react-router-dom'
import { Mode } from '@ocean/types/dist/appearance'
import { common } from '@ocean/ui'
import activityLogRoutes from 'modules/activityLog/common/routing/routes'
import routes from './routes'

export { routes }

const { RouteChangeProgress } = common

export const ElearningLogDetails = lazy(
  () =>
    import(
      /* webpackChunkName: "ActivityLogElearningLogDetails" */ 'modules/activityLog/details/ElearningLogDetails/pages/ElearningLogDetails'
    )
)

const ElearningLogDetailsRouting = () => (
  <Suspense fallback={<RouteChangeProgress mode={Mode.Light} />}>
    <Switch>
      <Route exact path={`${routes.root}/:elearningId`} component={ElearningLogDetails} />
      <Redirect path='*' to={activityLogRoutes.root} />
    </Switch>
  </Suspense>
)

export default ElearningLogDetailsRouting
